module.exports = {
    /**
     * 是否显示 tagsView
     */
    tagsView: true,
  
  }
  